import React, {useState, lazy, Suspense} from "react";
import {Route, Routes} from 'react-router-dom';
import { useAuth } from "../contexts/session";

import Header from "../components/header+footer/Header";
import Footer from "../components/header+footer/Footer";
// import NotificationBar from "../components/notifications/NotificationBar";
import Mole from '../components/icons/mole/Mole';
import Home from "./Home";
import EventFeedback from '../components/eventFeedback/EventFeedback';
import GlobalWebsocket from "../components/Websockets/GlobalWebsocket";
import PixelEdumanLoader from "../components/loading/PixelEdumanLoader";
import ProtectedRoute from "../components/accessControl/ProtectedRoute";

import '../assets/css/pages/pages-shared.css';
// import ContentFolder from "./Courses";


const UsersFolder = lazy(() => import("./Users"));
const CampusFolder = lazy(() => import("./Campus"));
const CertificatesFolder = lazy(() => import("./Centificates"));
const CoursesFolder = lazy(() => import("./Courses"));
const EvaluationsFolder = lazy(() => import("./Evaluations"));
const GroupsFolder = lazy(() => import("./Groups"));
const NewsFolder = lazy(() => import("./News"));
const PlansFolder = lazy(() => import("./Plans"));
const RolesFolder = lazy(() => import("./Roles"));
const SocialFolder = lazy(() => import("./Social"));
const StudentsFolder = lazy(() => import("./Students"));
const SubscriptionsFolder = lazy(() => import("./Subscriptions"));
const TransactionsFolder = lazy(() => import("./Transactions"));
const LearningFolder = lazy(() => import('./Learning'));
const CustomPortalFolder = lazy(() => import("./CustomPortal"));
const NotFoundFolder = lazy(() => import("./404/Index"));
const CoursePlayerFolder = lazy(() => import("./CoursePlayer"));
const GradeLevels = lazy(() => import("./GradeLevels/GradeLevels"));
const PackagesFolder = lazy(() => import("./Packages"));
const AccountSetup = lazy(() => import("./AccountSetup/AccountSetup"));
const Reports = lazy(() => import("./Reports"))

const MainSiteContainer = () => {

    const { userObj, isLoading } = useAuth();

    return(
        <>
            {/* MAIN tag & SESSIONPROVIDER HAVE MOVED TO APP.JS */}
            {/* <main>
                <SessionProvider>  */}
            <Header />
            <GlobalWebsocket />
            {/* <NotificationBar /> */}
            <div className="siteContentWrapper">
                <EventFeedback />
                <Suspense fallback={<PixelEdumanLoader message={"Loading..."} isFixed={true} />} >
                    {   (!isLoading && (userObj?.account_setup_complete === 0 || userObj?.account_setup_complete === 1)) ?
                        <>
                            {   userObj?.account_setup_complete ?
                                <>
                                        <Routes>
                                            <Route path="/Mole/*" element={<Mole />} />
                                            <Route path="/home/*" element={<Home />} />
                                            <Route path="/campus/*" element={<CampusFolder />} />
                                            <Route path="/certificates/*" element={<CertificatesFolder />} />
                                            {/* <Route path="/content/*" element={<ContentFolder />} /> */}
                                            <Route path="/courses/*" element={<ProtectedRoute accessControl={"courses"} contents={<CoursesFolder />} />} />
                                            <Route path="/groups/*" element={<GroupsFolder />} />
                                            <Route path="/news/*" element={<NewsFolder />} />
                                            <Route path="/plans/*" element={<ProtectedRoute accessControl="plans" contents={<PlansFolder />} />} />
                                            <Route path="/learning/*" element={<LearningFolder />} />
                                            <Route path="/customPortal/*" element={<CustomPortalFolder />} />
                                            <Route path="/roles/*" element={<RolesFolder />} />
                                            <Route path="/social/*" element={<SocialFolder />} />
                                            <Route path="/students/*" element={<StudentsFolder />} />
                                            <Route path="/subscriptions/*" element={<SubscriptionsFolder />} />
                                            <Route path="/transactions/*" element={<ProtectedRoute accessControl="transactions" contents={<TransactionsFolder />} />} />
                                            <Route path="/users/*" element={<ProtectedRoute accessControl="users" contents={<UsersFolder />} />} />
                                            <Route path="/coursePlayer/*" element={<CoursePlayerFolder />} />
                                            <Route path="/gradeLevels/*" element={<GradeLevels />} />
                                            <Route path="/packages/*" element={<PackagesFolder />} />
                                            <Route path="/evaluations/*" element={<EvaluationsFolder />} />
                                            <Route path="/reports/*" element={<Reports />} />
                                            <Route path="/*" element={<NotFoundFolder />} />
                                        </Routes>
                                </>
                                :
                                <>
                                    {/* USER TUTORIAL */}
                                    <AccountSetup userAuth={{userObj, isLoading}} />
                                </>
                            }
                        </>
                        :
                        <>
                            <PixelEdumanLoader isFixed={true} message={"Loading profile..."} />
                        </>
                    }
                </Suspense>
            </div>
            <Footer />
                {/* </SessionProvider>
            </main> */}
        </>
    );
};

export default MainSiteContainer;